<template>
    <v-container mt-0 pt-0>

    <div class="nonprint">
        <v-btn icon :to="returnPath">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="display-1 px-3">OilMatrix専用ラベルシート確認ページ</span>
    </div>

    <v-card flat outlined class="pa-3 nonprint">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">OilMatrix専用ラベルシートへの印刷でズレが出る場合こちらで確認してください</span>
      </div>
      <p class="title-1">
        普通紙（A4サイズ）に印刷するか、pdfに保存<br>
      </p>
      <v-btn 
        small 
        rounded 
        color="amber" 
        @click="barcodePrint()"
        class="mx-3 mt-5"
        id="ordersheet_btn"
        >
        <v-icon class="mr-2">mdi-printer</v-icon>
        お申込書を印刷する
      </v-btn>

    </v-card>

    <div v-if="!isErrorParam" class="ma-0 pa-0">

    <!-- Ａ 依頼書ヘッダ -->
    <v-simple-table  class="fixed_table ma-0 pa-0">
      <tbody>
        <tr>
          <td class="header_area ma-0 pa-0">
<!--
依頼書ヘッダ（190mm × 50mm）<br>
<br>
余白（上）17.0mm<br>
余白（左）10.0mm<br>
余白（右）10.0mm<br>
余白（下）10.0mm<br>
-->
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- Ｂ 外箱貼り付け用ラベル -->

    <v-simple-table class="fixed_table ma-0 pa-0">
      <tbody>
        <tr>
          <td class="box-sticker_area ma-0 pa-0">
<!--
<div class="sticker_text">Ｂ 外箱貼り付け用ラベル（90mm × 40mm）</div>
-->
          </td>
          <td  class="center_space">
            a
          </td>
          <td  class="box-sticker_area ma-0 pa-0">
<!--
  Ｂ 外箱貼り付け用ラベル（90mm × 40mm）
-->



          </td>
        </tr>
      </tbody>
    </v-simple-table>



    <!-- Ｃ-1 報告書情報（送付先、宛名） -->
    <v-simple-table class="fixed_table ma-0 pa-0">
      <tbody>
        <tr>
          <td class="report_area ma-0 pa-0">
<!--
Ｃ-1 報告書情報（送付先、宛名）（90mm × 50mm）
-->

          </td>


          <td  class="center_space ma-0 pa-0">
            a
          </td>


          <td  class="report_area ma-0 pa-0">
<!--
Ｃ-1 報告書情報（送付先、宛名）（90mm × 40mm）
-->


          </td>
        </tr>

    <!-- Ｃ-２ 報告書情報（送付先、宛名） -->
        <tr>
          <td class="box-sticker_area ma-0 pa-0">



          </td>
          <td  class="center_space ma-0 pa-0">
            a
          </td>
          <td  class="box-sticker_area ma-0 pa-0">


          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- Ｄ-1 サンプルヘッダ -->
    <v-simple-table class="fixed_table ma-0 pa-0">
      <tbody>
        <tr>
          <td class="sample_header_area ma-0 pa-0">
<!--
Ｄ-1 サンプルヘッダ（190mm × 50mm）
-->

          </td>
        </tr>
      </tbody>
    </v-simple-table>




    <!-- D-2 サンプルボトル貼り付け用ラベル -->
    <v-simple-table class="fixed_table ma-0 pa-0">
      <tbody>
        <tr>
          <td class="bottle_sticker_area ma-0 pa-0">
<!--
<div class="sticker_text">D-2 サンプルボトル貼り付け用ラベル（90mm × 40mm）</div>
-->

          </td>
          <td  class="center_space ma-0 pa-0">
            a
          </td>
          <td  class="bottle_sticker_area ma-0 pa-0">
<!--
D-2 サンプルボトル貼り付け用ラベル（90mm × 40mm）
-->

          </td>
        </tr>






      </tbody>
    </v-simple-table>


    </div>
  </v-container>
</template>

<script>

export default {
  components: {
//    VueQrcode
  },
  head: {
    title: { inner: '分析依頼書'},
  },
  data: () => ({
    applicationid: "",
  }),
  mounted: async function () {
    this.applicationid = this.$route.query.id
  },
  methods: {
    barcodePrint: async function () {
      window.print()
    },
  },
  computed: {
    returnPath() {
      return { path: '/ordersheet4labelsheet', query: { id: this.applicationid }}
    }
  }

}
</script>
<style lang="scss" scoped>

  .onlyprint { 
    display: none;
  }

  .outline {
    width: 70%;
  }

  .header_area {
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 0mm;
    width: 190.0mm;
    height: 50.0mm;
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;
  }

  .header_title {
    font-size : 18px !important;
    font-weight:bold;
  }

  .header_table {
    border:none !important;
  }

  .header_th {
//    width: 30mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .header_td {
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .header_qrcode {
//    width: 20mm;
    height: 0px;
    padding: 0mm;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }


  .box-sticker_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸90mm
    height: 40.0mm;   //原寸40mm
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .box-sticker_title {
    font-size : 12px !important;
  }

  .box-sticker_table {
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_th {
    font-size : 9px !important;
    width: 20mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_td {
    font-size : 9px !important;
//    width: 30mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_qrcode {
//    width: 20mm;
    height: 0px;
    padding: 0mm;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }


  .report_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸 90mm
    height: 50.0mm;   //原寸50mm
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .report_title {
    font-size : 12px !important;
  }

  .report_table {
//    border: 1px solid;
    border:none !important;
  }

  .report_td {
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .report_contents {
    padding: 0mm;
    font-size : 12px !important;
  }



  .sample_header_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 0mm;
    width:  190.0mm; // 原寸190
    height:  50.0mm; // 原寸50
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .sample_header_title {
    font-size : 10px !important;
    font-weight: bold;
    color: #ffffff;
    background-color: rgb(61, 57, 57);
    width: 100%;
    padding-left: 2mm;
  }

  .sample_header_table {
//    border: 1px solid;
    border:none !important;
  }


  .sample_header_th {
    font-size : 5px !important;
//    width: 35mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .sample_header_td {
    font-size : 5px !important;
//    width: 40mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .sample_header_qrcode {
//    width: 20mm;
    height: 0px;
    padding: 0mm;
    text-align: center;
//    border: 1px solid;
    border:none !important;
  }

  .bottle_sticker_area {
//    font-family: serif;
    font-size : 5px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸90mm
    height: 40.0mm; //原寸40mm
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .bottle_sticker_table {
    table-layout: fixed;
//    border: 1px solid;
    border:none !important;
  }


  .bottle_sticker_th {
    font-size : 5px !important;
    width: 20mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .bottle_sticker_td {
    font-size : 5px !important;
    word-break : break-all;
//    width: 40mm;
    height: 0px;
    padding: 0mm;
//    border: 1px solid;
    border:none !important;
  }

  .sticker_text {
    width: 100%;
  }

  .sticker_text2 {
    width: 100%;
  }

  .sticker_text3 {
    width: 100%;
  }

  .bottle_sticker_qrcode {
  //    width: 20mm;
      height: 0px;
      padding: 0mm;
      text-align: center;
      vertical-align: middle;
//    border: 1px solid;
    border:none !important;
    }

  .center_space {
    width: 10mm;
    padding: 0mm;
    margin: 0px !important;
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;
  }

  .pagebreak {
    break-after: page;
  }
@page {
  size: A4 portrait; // 横の場合はlandscape

  margin-top:    17.0mm; //原寸17mm
  margin-bottom: 10.0mm; //原寸10mm

  margin-left:   10.0mm; //原寸10mm
  margin-right:  10.0mm; //原寸10mm
}

@media print {
/*
  .page {
    width: 190mm;
    height: 269mm;
    page-break-after: always;

    box-sizing: border-box;
  //    padding: 20mm 25mm;
  //    font-size: 11pt;
  }
*/


  body {
    padding: 0;
//    height: 269.5mm; // A4サイズ
//    width: 189.5mm; // needed for Chrome
  }

  .fixed_table {
    display: table !important;
    table-layout: fixed;
  }

  .outline {
    width: 100%;
  }

  .header_area {
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 0mm;
    width: 190.0mm;
    height: 50.0mm;
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .header_title {
    font-size : 18px !important;
    font-weight:bold;
  }

  .header_table {
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .header_th {
//    width: 30mm;
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .header_td {
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .header_qrcode {
//    width: 20mm;
    height: 0px;
    padding: 0mm;
    text-align: center;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }


  .box-sticker_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    width:  90.0mm; //原寸90mm
    height: 40.0mm;   //原寸40mm
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .box-sticker_title {
    font-size : 12px !important;
  }

  .box-sticker_table {
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_th {
    font-size : 9px !important;
    width: 20mm;
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_td {
    font-size : 9px !important;
//    width: 30mm;
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .box-sticker_qrcode {
//    width: 20mm;
    height: 0px;
    padding: 0mm;
    text-align: center;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }


  .report_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸 90mm
    height: 50.0mm;   //原寸50mm
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .report_title {
    font-size : 12px !important;
  }

  .report_table {
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .report_td {
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .report_contents {
    padding: 0mm;
    font-size : 12px !important;
  }

  .sample_header_area {
//    font-family: serif;
    font-size : 12px !important;
    text-align: left;
    vertical-align: top;
    padding: 0mm;
    width: 190.0mm; // 原寸190
    height: 50.0mm; // 原寸50
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .sample_header_title {
    font-size : 10px !important;
    font-weight: bold;
    color: #ffffff;
    background-color: rgb(61, 57, 57) !important;
    -webkit-print-color-adjust: exact;
    width: 100%;
    padding-left: 2mm;
  }

  .sample_header_table {
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }


  .sample_header_th {
    font-size : 6px !important;
    width: 25mm;
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .sample_header_td {
    font-size : 6px !important;
    width: 25mm;
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .sample_header_qrcode {
    width: 25mm;
    height: 0px;
    padding: 0mm;
    text-align: center;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .bottle_sticker_area {
//    font-family: serif;
    font-size : 5px !important;
    text-align: left;
    vertical-align: top;
    padding: 1mm;
    width:  90.0mm; //原寸90mm
    height: 40.0mm; //原寸40mm
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;

  }

  .bottle_sticker_table {
    table-layout: fixed;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }


  .bottle_sticker_th {
    font-size : 5px !important;
    width: 20mm;
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .bottle_sticker_td {
    font-size : 5px !important;
    word-break : break-all;
//    width: 40mm;
    height: 0px;
    padding: 0mm;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }

  .sticker_text {
    width: 120%;
    -webkit-transform:scale(0.8);
    -moz-transform:scale(0.8);
    -ms-transform:scale(0.8);
    -o-transform:scale(0.8);
    transform:scale(0.8);
    transform-origin: left center;
  }

  .sticker_text2 {
    width: 150%;
    font-size: 10px;
    transform:scale(0.6);
    transform-origin: left center;
  }

  .sticker_text3 {
    width: 200%;
    font-size: 10px;
    transform:scale(0.5);
    transform-origin: left center;
  }

  .bottle_sticker_qrcode {
//    width: 20mm;
    height: 0px;
    padding: 0mm;
    text-align: center;
    vertical-align: middle;
    box-sizing: border-box;
//    border: 1px solid;
    border:none !important;
  }



  .center_space {
    width: 10.0mm;
    padding: 0mm;
    margin: 0px !important;
    box-sizing: border-box;
    border: 1px solid;
//    border:none !important;
  }

  .pagebreak {
    break-after: page;
  }

  .nonprint { 
    display: none;
  }

  .onlyprint { 
    display: block;
  }
}
</style>